<template>
    <div class="mt-2">
        <v-chip 
            :class="{ 'resources-filters__tag mr-4 mt-4': true, 'resources-filters__tag-active': tag === currentTag }"
            v-for="tag in tags" 
            :key="tag"
            @click="toggleTag(tag)"
        >
            {{ tag }}
        </v-chip>
    </div>
</template>

<script>
export default {
    props: {
        tags: {
            type: Array,
            default: () => []
        },
        currentTag: {
            type: String,
            default: 'All'
        }
    },
    methods: {
        toggleTag(tag) {
            this.$emit('toggleTag', tag)
        }
    }
}
</script>

<style lang="scss">
.resources-filters {
    &__tag {
        height: 46px !important;
        padding: 0;
        font-size: 18px !important;
        font-weight: 700;
        line-height: 22px;
        letter-spacing: 0.36px;
        font-family: Montserrat, sans-serif;
        color: var(--accent-color) !important;
        background-color: transparent !important;
        border: 1px solid var(--accent-color) !important;
        border-radius: 22px !important;

        @media (max-width: 480px) {
            font-size: 14px;
            height: 32px !important;
        }

        & .v-chip__content {
            padding: 12px 20px !important;

            @media (max-width: 480px) {
                padding: 6px 10px !important;
            }
        }
    }
    
    &__tag-active {
        background-color: var(--accent-color) !important;
        color: #fff !important;
    }
}
</style>